const showHelpVideosAndTours = () => {
    const poweredBy = document.querySelector('meta[name="powered_by"]');
    if (!poweredBy) {
        return false;
    }

    return parseInt(poweredBy.content);
}

const state = {
    showHelpVideosAndTours: showHelpVideosAndTours(),
};

const getters = {
  showHelpVideosAndTours: ({ showHelpVideosAndTours }) => showHelpVideosAndTours,
};

export default {
  namespaced: true,
  state,
  getters,
};
